import React from 'react';

const variantClass = {
  teal:    'badge-teal',
  danger:  'badge-danger',
  gold:    'badge-gold',
  accent:  'badge-accent',
  muted:   'badge-muted',
  success: 'badge-teal',
  error:   'badge-danger',
  warning: 'badge-gold',
};

export default function Badge({ variant = 'muted', children, dot = false }) {
  return (
    <span className={variantClass[variant] ?? 'badge-muted'}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current mr-1.5 inline-block" />}
      {children}
    </span>
  );
}
